var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.714286,
    y: 0.714286,
    width: 38.5714,
    height: 38.5714,
    rx: 19.2857,
    stroke: "#E0E0E2",
    strokeWidth: 1.42857
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2103_22497",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 36,
    height: 36
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.85742,
    y: 2.85645,
    width: 34.2857,
    height: 34.2857,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2103_22497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6369 28.0764L21.1312 26.5271L26.5873 21.0711H9.28516V18.9282H26.5873L21.1312 13.4721L22.6369 11.9229L30.7137 19.9996L22.6369 28.0764Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.2ff2cb142fc608483a4be3a8b3dc263f.svg";
export { ForwardRef as ReactComponent };